import TabViewState, { TabType, TabState } from '../store/schema/TabViewState';
import datapoints from '../datapoints';
import getActiveContentTab from '../utils/getActiveContentTab';
import setTabIsShown from './setTabIsShown';
import toggleChatTab from './toggleChatTab';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { getTabHandler } from '../utils/TabHandler';

export default createLegacyActionWithDatapoint(
    'activateTab',
    datapoints.TabViewActivateTab
)(function (viewState: TabViewState, isUserAction?: boolean) {
    setTabIsShown(viewState, true /*isShown*/);

    switch (viewState.type) {
        case TabType.FloatingChat:
            toggleChatTab(viewState);
            return;
        case TabType.Primary:
        case TabType.OverflowMenu:
        case TabType.SecondaryReadingPane:
        case TabType.Compose:
            if (viewState.state != TabState.Active) {
                const activeTab = getActiveContentTab();

                if (activeTab) {
                    activeTab.state = TabState.Minimized;
                    const handler = getTabHandler(activeTab.type);
                    if (handler?.onDeactivate) {
                        handler.onDeactivate(activeTab);
                    }
                }

                if (viewState) {
                    viewState.state = TabState.Active;
                    viewState.blink = false;
                    const handler = getTabHandler(viewState.type);
                    if (handler?.onActivate) {
                        handler.onActivate(viewState);
                    }
                }
            }
            return;
    }
});
